export default "__VITE_ASSET__B1Cfa9ln__"